import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import api from './api/index';
import axios from 'axios/index';
import utils from './utils'   
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation, Scrollbar ,EffectCoverflow} from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// import 'swiper/swiper.less'
import 'swiper/swiper-bundle.css'
import { Breadcrumb as AlBreadcrumb } from "./components/index"
import { HoverBox } from "./components/al/hoverbox/index"

// 引入elementui
import { Tabs, TabPane,Loading ,Dialog,Button} from "element-ui";
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
document.title='第五届中以创新创业大赛'
library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)

Vue.component("al-breadcrumb", AlBreadcrumb)
Vue.component("al-hoverbox", HoverBox);

SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, Scrollbar,EffectCoverflow])
Vue.use(getAwesomeSwiper(SwiperClass))
// const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass) 
Vue.use(Loading.directive)
Vue.use(Dialog);
Vue.use(Button);

Vue.prototype.$loading = Loading.service
Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$utils = utils;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
